
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import sampleBg from '../../images/sample.png';
import likeActive from '../../images/icons/favorite-active.svg';
import likeInactive from '../../images/icons/favorite-inactive.svg';

class ActivityCard extends PureComponent {
    render () {
        const { imgSrc, classes, url, liked, item } = this.props;
        if(!item.organisation) return null;
        console.log(item);
        return (
            <div className={['activity-card', classes && classes].join(' ')}>
                <a href={`/livewell-finder/${item.organisation.slug}/${item.slug}/`}>
                    <div className="aspect-ratio-image" style={{ backgroundImage: `url(${item.main_image ? item.main_image : sampleBg})` }}>
                        <div className="inner">
                            <p className="tag-label light">{item.price === null ? '' : item.price}</p>
                            <MediaQuery minWidth={768}>
                                <p className="tag-label light">{(Math.round(item.distance * 100) / 100).toFixed(2)} Miles</p>
                            </MediaQuery>

                        </div>
                    </div>
                    <div className="card-content">
                        {(item.pathways && item.pathways.length) ?
                            <div className="pathways-bar">
                                {item.pathways.map(pitem => (<span key={pitem.id} className={`${pitem.pathway}`}></span>))}
                            </div>
                            : null
                        }
                        <h4>{item.organisation.name}</h4>
                        <MediaQuery minWidth={768}>
                            {(matches) => matches ? (
                                <p className="tag-label">{item.activity_name}</p>
                            ) : (
                                <div className="tag-labels">
                                    <p className="tag-label">{item.activity_name}</p>
                                    <p className="tag-label with-icon">
                                        <span>{(Math.round(item.distance * 100) / 100).toFixed(2)} Miles</span>
                                        <i className="icon icon-location-mark-grey"></i>
                                    </p>
                                </div>
                            )}
                        </MediaQuery>
                    </div>
                </a>

                {/* <button className="liked-toggle-button">
                    <img src={liked ? likeActive: likeInactive} alt="button-icon" />
                </button> */}
            </div>
        );
    }
}

ActivityCard.propTypes = {
    classes: PropTypes.string,
    liked: PropTypes.bool,
    item: PropTypes.object
};

ActivityCard.defaultProps = {
    classes: null,
    liked: false
};

export default ActivityCard;
